import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  Input,
  EventEmitter,
  Output,
} from '@angular/core'
import { LaunchDialogService, ICON_TYPE } from '@spartacus/storefront'
import { CommonService } from '../../../../shared/services/common.service'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'
import { PRE_URL } from '../../../../shared/constants'

@Component({
  standalone: false,
  selector: 'app-extend-cart-expiry-dialog',
  templateUrl: './extend-cart-expiry-dialog.component.html',
  styleUrls: ['./extend-cart-expiry-dialog.component.scss'],
})
export class ExtendCartExpiryDialogComponent implements OnInit {
  iconTypes = ICON_TYPE
  modalIsOpen = false

  currentUser = null

  currentCart = null

  @Output() extendExpiryStatus = new EventEmitter()

  @ViewChild('dialog', { read: ElementRef })
  dialog: ElementRef

  constructor(
    private launchDialogService: LaunchDialogService,
    private commonService: CommonService,
    private globalMessageService: GlobalMessageService
  ) {}

  ngOnInit() {
    this.launchDialogService.data$.subscribe((data) => {
      this.currentUser = data.currentUser
      this.currentCart = data.currentCart
    })
  }

  dismissModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.EXTEND_CART_EXPIRY,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }

  extendExpiry() {
    if (!this.currentUser.uid || !this.currentCart.code) {
      return
    }
    this.commonService
      .postData(
        `${PRE_URL}/users/current/${this.currentCart.code}/extenddate`,
        {},
        { responseType: 'text' as 'json' }
      )
      .subscribe(
        () => {
          setTimeout(() => {
            window.scrollTo(0, 0)
          }, 1000)
          this.dismissModal('Dismissing after successful save')
          this.extendExpiryStatus.emit({
            extendedExpiry: true,
            cartName: this.currentCart.name,
          })
          this.globalMessageService.add(
            {
              key: 'savedCart.cartExtendSuccess',
              params: { cartName: this.currentCart.name },
            },
            GlobalMessageType.MSG_TYPE_CONFIRMATION,
            9000
          )
          window.scrollTo(0, 0)
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
          window.scrollTo(0, 0)
        }
      )
  }
}
